import { gql } from '@apollo/client';

const AI_GET_PROMPT = gql`
    query GetPrompt($id: UUID!) {
        prompt(id: $id) {
            id
            companyId
            label
            prompt
            sql
            isSaved
            reportCount
            createdAt
            updatedAt
        }
    }
`;

export default AI_GET_PROMPT;
